import { render, staticRenderFns } from "./PollMultipleEditorItem.vue?vue&type=template&id=7f671172&scoped=true"
import script from "./PollMultipleEditorItem.vue?vue&type=script&lang=js"
export * from "./PollMultipleEditorItem.vue?vue&type=script&lang=js"
import style0 from "./PollMultipleEditorItem.vue?vue&type=style&index=0&id=7f671172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f671172",
  null
  
)

export default component.exports